import React from 'react';
import { ShieldCheck, BookOpen, Clock } from 'lucide-react';
import '../styles/DistilledSources.css';

/**
 * Premium "Distilled from the best" strip — replaces the older buried sources list.
 * Shown high on the page (right after the hero) so the credibility framing is
 * one of the first things parents read.
 *
 * Each source is shown as a wordmark pill, not a tiny dot-separated list.
 */

const SOURCES = [
  { name: 'Australian eSafety Commissioner', short: 'eSafety', accent: '#0F4C81' },
  { name: 'Australian Centre to Counter Child Exploitation', short: 'ACCCE', accent: '#143A6B' },
  { name: 'Australian Federal Police', short: 'AFP', accent: '#0d3b66' },
  { name: 'Kids Helpline', short: 'Kids Helpline', accent: '#D7263D' },
  { name: "Dolly's Dream", short: "Dolly's Dream", accent: '#9B2D6B' },
  { name: 'Telethon Kids Institute', short: 'Telethon Kids', accent: '#1D7A50' },
];

const DistilledSources = () => (
  <section className="ds-section" data-testid="distilled-sources">
    <div className="hb-container">
      <div className="ds-card">
        <div className="ds-head">
          <span className="ds-eyebrow">
            <ShieldCheck size={12} /> Why parents trust this handbook
          </span>
          <h2 className="ds-title">
            We read every major Australian source on child digital safety —
            and <span className="ds-italic">distilled it into one calm guide.</span>
          </h2>
          <p className="ds-sub">
            You don't have time to wade through dozens of government PDFs, charity reports
            and policy papers. We did. The handbook brings the most practical guidance from
            six respected Australian voices into one place — in plain English, written for
            everyday parents.
          </p>
        </div>

        <div className="ds-stats">
          <div className="ds-stat">
            <span className="ds-stat-num">6</span>
            <span className="ds-stat-label">trusted sources</span>
          </div>
          <span className="ds-stat-rule" aria-hidden="true" />
          <div className="ds-stat">
            <span className="ds-stat-num">40<small>+</small></span>
            <span className="ds-stat-label">hours of research</span>
          </div>
          <span className="ds-stat-rule" aria-hidden="true" />
          <div className="ds-stat">
            <span className="ds-stat-num">1</span>
            <span className="ds-stat-label">calm parent guide</span>
          </div>
        </div>

        <div className="ds-sources" data-testid="ds-sources-list">
          {SOURCES.map((s) => (
            <div key={s.short} className="ds-source" title={s.name} data-testid={`ds-source-${s.short.toLowerCase().replace(/[^a-z]/g, '-')}`}>
              <span className="ds-source-dot" style={{ background: s.accent }} aria-hidden="true" />
              <span className="ds-source-name">
                <span className="ds-source-short">{s.short}</span>
                <span className="ds-source-full">{s.name}</span>
              </span>
            </div>
          ))}
        </div>

        <div className="ds-footer">
          <span className="ds-footer-row">
            <BookOpen size={13} />
            <span><strong>Drawn from publicly available material.</strong> Source names shown for transparency; no endorsement implied.</span>
          </span>
          <span className="ds-footer-row">
            <Clock size={13} />
            <span><strong>Reviewed annually.</strong> Last reviewed February 2026.</span>
          </span>
        </div>
      </div>
    </div>
  </section>
);

export default DistilledSources;
